import axios from '@/plugins/axios'
import {Message, MessageBox} from "element-ui";

export default {
  namespaced: true,

  state: {
    loading: false,
    videos: [],
    page: 1,
    page_size: 10,
    order_column: 'created_at',
    order_type: 'desc'
  },

  mutations: {
    setVideo(state, payload) {
      state.videos = payload
    },
    setPageVideo(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    }
  },

  actions: {
    readFreeVideos({ commit, state }, filters = null) {
      commit('setLoading', true)

      let ls = localStorage.getItem('video_track_scan_filter')
      filters = JSON.parse(ls)

      axios.admin
        .get('vc/freeVideos', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            video_type: 1,
            ...filters
          }
        })
        .then(r => {
          commit('setVideo', r.data.freeVideos)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    update({ dispatch }, payload) {
      axios.admin
        .post(`vc/video-tracks-scan`, {
          ...payload
        })
        .then(() => {
          dispatch('readFreeVideos')
          Message({
            type: 'success',
            message: 'You have successfully updated record'
          })
        })
    },
    approve({ dispatch }, payload) {
      Object.assign(payload, {
        video_approved: 1
      })
      axios.admin
        .post(`vc/video-tracks-scan`, {
          ...payload
        })
        .then(() => {
          Object.assign(payload, {
            video_approved: 1
          })
          dispatch('readFreeVideos')
        })
    },
    reject({ dispatch }, payload) {
      MessageBox.confirm(`You will return VidCents. Continue?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        Object.assign(payload, {
          video_approved: 0
        })
        axios.admin
          .post(`vc/video-tracks-scan`, {
            ...payload
          })
          .then(() => {
            Message({
              type: 'success',
              message: 'VidCents returned'
            })
            dispatch('readFreeVideos')
          })
          .catch(() => {
            Message({
              type: 'info',
              message: 'VidCents return cancelled'
            })
          })
      })
    }
  }
}
